import React from 'react';

const CustomTooltip = ({ children, text, showTooltip }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* ✅ Always allow interaction */}
      <span>{children}</span>

      {hovered && showTooltip && (
        <div
          style={{
            position: 'absolute',
            top: '-35px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#00d095',
            color: '#fff',
            padding: '6px 10px',
            borderRadius: '4px',
            fontSize: '14px',
            whiteSpace: 'nowrap',
            zIndex: 1000
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
